import React, { useEffect } from "react";
import cl from "./RefundPolicy.module.css";
import { animateScroll as scroll } from "react-scroll";

const RefundPolicy = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.app_policy}>
      <h1>Refund policy</h1>
      <p>Last updated: February 07, 2024</p>
      <h2>Cancellation</h2>
      <p>
        We accept order cancellation before the product is shipped or produced.
        If the order is canceled you will get full refund. We cannot cancel the
        order if the product is already shipped out.
      </p>

      <h2>Returns (if applicable)</h2>
      <p>
        We accept return of products. Customers have the right to apply for a
        return within 14 days after the receipt of the product.
        <br />
        To be eligible for a return, your item must be unused and in the same
        condition that you received it. It must also be in the original
        packaging. To complete your return, we require a receipt or proof of
        purchase. Please do not send your purchase back to the manufactureror
        our transit station.
      </p>
    </section>
  );
};

export default RefundPolicy;
